'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _companyAutocomplete = require('./company-autocomplete.component');

var _companyAutocomplete2 = _interopRequireDefault(_companyAutocomplete);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('common.autocomplete.company', []).component('companyAutocomplete', _companyAutocomplete2.default).value('EventEmitter', function (payload) {
  return { $event: payload };
}).name;


// WEBPACK FOOTER //
// ./components/app/common/autocomplete/company/company-autocomplete.module.js